import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[bsRewardTokensDrawerScroll]',
    standalone: false,
})
export class RewardTokensDrawerScrollDirective implements AfterViewInit {
    @Input('bsRewardTokensDrawerScroll') isEnabled = false;

    private observer: ResizeObserver;

    constructor(private element: ElementRef<HTMLElement>) {
        this.observer = new ResizeObserver(() => {
            this.scrollOnce();
        });
    }

    ngAfterViewInit(): void {
        if (!this.isEnabled) {
            return;
        }

        this.observer.observe(this.element.nativeElement);
    }

    private scrollOnce() {
        this.observer.disconnect();

        setTimeout(() => {
            this.element.nativeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }, 200);
    }
}
